/*
 *
 * ManageUserModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 25-Mar-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  apiKey: <PortalMessage id='t.app.settings.apiKey.apiKeyLabel' defaultMessage='API Key' />,
  copiedText: <PortalMessage id='t.app.settings.apiKey.modal.textCopied' defaultMessage='Apikey copied' />,
  showApiKeyMessage: (selectedTerminalId, content) => (
    <PortalMessage
      id='t.app.settings.apiKey.modal.showApiKey'
      defaultMessage='API Key for the {selectedTerminalId} terminal: <span>{content}</span>'
      values={{ selectedTerminalId, content: <span>{content}</span> }}
    />
  )
}

export const captions = defineMessages({
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  copy: {
    id: 't.app.settings.apiKey.btn.copy',
    defaultMessage: 'Copy'
  },
  copied: {
    id: 't.app.settings.apiKey.btn.copied',
    defaultMessage: 'Copied'
  },
  show: {
    id: 't.app.settings.apiKey.btn.show',
    defaultMessage: 'Show'
  }
})

export default formattedMessage
